
//Représente les données d’un onglet
export class DonneesOnglet 
{
  //Création
  constructor ()
  {
    this.identifiant = "";
    this.libelle = "";
    this.couleur = null;
    this.icone = null;
    this.iconeCouleur = null;
    this.selectionne = false;
    this.nombreLignesChargees = null;
    this.chargementComplet = false;
  }

  //Identifiant
  public identifiant: string;

  //Libellé
  public libelle: string;

  //Couleur
  public couleur: number | null;

	//Icone
	public icone: string | null;

	//Couleur de l’icone
	public iconeCouleur: number | null;

  //Indique si sélectionné
  public selectionne: boolean;

  //Nombre de lignes chargées dans la grille
  //  null tant que l’onglet n’a rien chargé : aucun compteur n’est alors affiché.
  //  Renseigné uniquement par les onglets de grille de recherche — les barres d’onglets
  //  de fiche (facture achat / vente) le laissent à null et restent inchangées.
  public nombreLignesChargees: number | null;

  //Indique si toutes les lignes ont été chargées
  //  Faux tant qu’une page suivante peut exister : le compteur se note alors (>x).
  public chargementComplet: boolean;
}